/* ==========================================================================
   Devotee Stories — video play / pause
   Progressive enhancement: without this file the poster + button still
   render, they just don't do anything. Nothing else in the section
   depends on it.
   ========================================================================== */
(function () {
  'use strict';

  var MEDIA = '[data-dv-video]';

  /* Only one testimonial video plays at a time. */
  function pauseOthers(current) {
    document.querySelectorAll(MEDIA + ' .dv__video').forEach(function (video) {
      if (video !== current && !video.paused) video.pause();
    });
  }

  function setup(media) {
    if (media.dataset.dvVideoReady === 'true') return;

    var video = media.querySelector('.dv__video');
    if (!video) return;

    media.dataset.dvVideoReady = 'true';

    var button = media.querySelector('.dv__play');
    var playLabel = (button && button.dataset.playLabel) || 'Play video';
    var pauseLabel = (button && button.dataset.pauseLabel) || 'Pause video';

    function sync() {
      var playing = !video.paused && !video.ended;
      media.classList.toggle('is-playing', playing);
      if (button) button.setAttribute('aria-label', playing ? pauseLabel : playLabel);
    }

    function toggle(event) {
      /* Cards can be wrapped in a link — don't navigate on a play tap. */
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (video.paused) {
        pauseOthers(video);
        var played = video.play();
        if (played && typeof played.catch === 'function') {
          played.catch(function () {
            /* Autoplay/gesture policy blocked it — stay in the paused state. */
            sync();
          });
        }
      } else {
        video.pause();
      }
    }

    if (button) button.addEventListener('click', toggle);
    video.addEventListener('click', toggle);

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', function () {
      if (!video.loop) video.currentTime = 0;
      sync();
    });

    /* Pause once the card is scrolled well out of view. */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && !video.paused) video.pause();
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(media);
    }

    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll(MEDIA).forEach(setup);
  }

  function pauseWithin(scope) {
    if (!scope) return;
    scope.querySelectorAll('.dv__video').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    pauseWithin(event.target);
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    pauseWithin(event.target);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    pauseWithin(event.target);
  });
})();
